module.exports = __webpack_public_path__ + "static/media/backgroundImg2.f5e8b73b.png";